// Single source of truth for every page's search-engine metadata.
// Edit the copy here — RouteSeo applies it automatically based on the URL.

export const SITE_URL = "https://www.saleementerprises.com";
export const DEFAULT_OG_IMAGE = "/Logo.webp";

export interface PageSeo {
  title: string;
  description: string;
}

/** Keyed by pathname. Every indexable route must appear here. */
export const PAGE_SEO: Record<string, PageSeo> = {
  "/": {
    title: "Greenhouse Manufacturer in Pakistan | Saleem Enterprises",
    description:
      "Saleem Enterprises designs and builds glasshouses, polycarbonate and tunnel greenhouses, screen houses and hydroponic systems across Pakistan, with PLC, HMI and IoT climate automation.",
  },
  "/projects": {
    title: "Greenhouse Projects & Installations in Pakistan",
    description:
      "Greenhouse projects delivered for research institutions, commercial growers and NGOs: speed breeding glasshouses, polycarbonate, polyethene, screen houses and hydroponics.",
  },
  "/portfolio": {
    title: "Portfolio — Completed Greenhouse Projects",
    description:
      "A visual portfolio of controlled-environment agriculture projects built by Saleem Enterprises across Pakistan, from research glasshouses to commercial tunnel farms.",
  },
  "/green-house": {
    title: "Intelligent Speed Breeding Glasshouse | Research Greenhouses",
    description:
      "Research-grade speed breeding glasshouses engineered for maximum light transmission, precise climate control and reliable year-round crop cycles.",
  },
  "/polycarbonate": {
    title: "Polycarbonate Greenhouses in Pakistan — Twin-Wall Panels",
    description:
      "Twin-wall polycarbonate greenhouses with exhaust fans and cooling pads: insulated, durable and built for year-round commercial vegetable and flower production.",
  },
  "/polythene": {
    title: "Polyethene & Tunnel Greenhouses — Low-Cost Protected Farming",
    description:
      "Multi-span and tunnel greenhouses covered with high-grade PE film. Roll-up side ventilation and easy film replacement suit growers scaling protected cultivation affordably.",
  },
  "/screen-house": {
    title: "Screen Houses & Insect-Proof Net Houses in Pakistan",
    description:
      "Screen houses with durable shading and anti-insect netting that create a controlled microclimate, ideal for nurseries, plant hardening and pest-sensitive crops.",
  },
  "/hydroponics": {
    title: "Hydroponic Systems in Pakistan — NFT & Dutch Bucket",
    description:
      "Automated soilless growing systems using Nutrient Film Technique and Dutch bucket methods, with precision fertigation, water recycling and remote monitoring.",
  },
  "/automation-detail": {
    title: "Greenhouse Automation & IoT Control — PLC, HMI, SCADA",
    description:
      "Industrial greenhouse automation: PLC control, touchscreen HMI panels, SCADA for multi-site operations, and IoT dashboards with real-time monitoring and remote alerts.",
  },
  "/fertigation-systems": {
    title: "Climate Control & Fertigation Systems for Greenhouses",
    description:
      "Precision climate control and automated fertigation: temperature, humidity, airflow, CO₂ enrichment, LED lighting and accurate nutrient dosing for crop-specific microclimates.",
  },
  "/turnkey-projects": {
    title: "Turnkey Greenhouse Projects — Design to Handover",
    description:
      "Complete turnkey greenhouse delivery: structure, automation and IoT systems, vertical farming setups, plus safety and alarm systems, installed and handed over ready to grow.",
  },
  "/research-detail": {
    title: "Agricultural R&D — Smart Greenhouse Technology",
    description:
      "Research and development in AI-driven greenhouse automation, climate intelligence and sustainable system design, with agronomists and academic partners.",
  },
  "/quality-detail": {
    title: "Innovation in Agriculture — Saleem Enterprises",
    description:
      "How Saleem Enterprises applies intelligent automation, IoT and advanced climate control to turn greenhouses into sustainable, high-performance growing ecosystems.",
  },
  "/customize-solution": {
    title: "Custom Greenhouse Solutions Built to Your Crop & Climate",
    description:
      "Every greenhouse is custom engineered: structure dimensions, covering materials, ventilation and automation tailored to your crop type, local climate and operational goals.",
  },
  "/blog": {
    title: "News & Insights — Saleem Enterprises",
    description:
      "News, project milestones and insights on controlled-environment agriculture, greenhouse automation and precision farming in Pakistan.",
  },
  "/contact": {
    title: "Contact Saleem Enterprises — Faisalabad, Pakistan",
    description:
      "Contact Saleem Enterprises for greenhouse design, automation and fertigation projects. Based in Faisalabad, Pakistan. Call +92 306 666 5542 or email info@saleementerprises.com.",
  },
};

/**
 * Routes that render the same component as a canonical URL above.
 * They point search engines at the canonical version instead of competing with it.
 */
export const CANONICAL_ALIASES: Record<string, string> = {
  "/projects-detail": "/projects",
};
